import styled from 'styled-components';
import { StyledPopUpBlock, StyledCross } from '../styled';

export const StyledCrossIcon = styled(StyledCross)`
  right: 22px;
`;

export const StyledPopupHeader = styled.div`
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  z-index: 1;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const StyledPopUpBlockNoPadding = styled(StyledPopUpBlock)`
  padding: 0;
  max-width: 520px;
  max-height: 650px;
  border-radius: ${({ theme }) => theme.cardRadius};
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.border};
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
`;
export const StyledParagraph = styled.p`
  margin-top: 20px;
  font-family: 'Archivo';
  font-size: 15px;
  line-height: 26px;
  padding: 30px;
  text-align: center;
`;
